import ActivityLog from './react-icons/ActivityLog'
import Add from './react-icons/Add'
import Alert from './react-icons/Alert'
import ArrowLeft from './react-icons/ArrowLeft'
import ArrowRight from './react-icons/ArrowRight'
import Attachment from './react-icons/Attachment'
import Billing from './react-icons/Billing'
import Bullet from './react-icons/Bullet'
import Brochures from './react-icons/Brochures'
import Buoy from './react-icons/Buoy'
import Calendar from './react-icons/Calendar'
import Call from './react-icons/Call'
import CaretDown from './react-icons/CaretDown'
import CaretUp from './react-icons/CaretUp'
import Change from './react-icons/Change'
import Chat from './react-icons/Chat'
import ClearOutline from './react-icons/ClearOutline'
import Clipboard from './react-icons/Clipboard'
import Close from './react-icons/Close'
import Dashboard from './react-icons/Dashboard'
import Doc from './react-icons/Doc'
import Document from './react-icons/Document'
import Download from './react-icons/Download'
import EllipsisVertical from './react-icons/EllipsisVertical'
import Exchange from './react-icons/Exchange'
import Exclamation from './react-icons/Exclamation'
import Expand from './react-icons/Expand'
import External from './react-icons/External'
import ExternalLine from './react-icons/ExternalLine'
import Eye from './react-icons/Eye'
import Faq from './react-icons/Faq'
import Filter from './react-icons/Filter'
import Globe from './react-icons/Globe'
import Hourglass from './react-icons/Hourglass'
import Innovation from './react-icons/Innovation'
import Img from './react-icons/Img'
import License from './react-icons/License'
import Loading from './react-icons/Loading'
import Lock from './react-icons/Lock'
import Lookup from './react-icons/Lookup'
import Menu from './react-icons/Menu'
import Orders from './react-icons/Orders'
import Pdf from './react-icons/Pdf'
import Partnership from './react-icons/Partnership'
import Performance from './react-icons/Performance'
import Personalisation from './react-icons/Personalisation'
import Play from './react-icons/Play'
import Policies from './react-icons/Policies'
import Pound from './react-icons/Pound'
import Ppt from './react-icons/Ppt'
import Preferences from './react-icons/Preferences'
import Products from './react-icons/Products'
import Profile from './react-icons/Profile'
import Question from './react-icons/Question'
import Reports from './react-icons/Reports'
import Request from './react-icons/Request'
import Results from './react-icons/Results'
import Search from './react-icons/Search'
import SignOut from './react-icons/SignOut'
import SortFilter from './react-icons/SortFilter'
import Tag from './react-icons/Tag'
import TechnicalGuides from './react-icons/TechnicalGuides'
import Training from './react-icons/Training'
import Trust from './react-icons/Trust'
import Txt from './react-icons/Txt'
import Tick from './react-icons/Tick'
import TickLine from './react-icons/TickLine'
import Time from './react-icons/Time'
import Trash from './react-icons/Trash'
import User from './react-icons/User'
import UserList from './react-icons/UserList'
import Users from './react-icons/Users'
import Wrench from './react-icons/Wrench'
import Xls from './react-icons/Xls'
import Zip from './react-icons/Zip'

const IconMapper = {
  activityLog: ActivityLog,
  add: Add,
  alert: Alert,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  attachment: Attachment,
  billing: Billing,
  bullet: Bullet,
  brochures: Brochures,
  buoy: Buoy,
  calendar: Calendar,
  call: Call,
  caretDown: CaretDown,
  caretUp: CaretUp,
  change: Change,
  chat: Chat,
  clearOutline: ClearOutline,
  clipboard: Clipboard,
  close: Close,
  dashboard: Dashboard,
  doc: Doc,
  document: Document,
  download: Download,
  ellipsisVertical: EllipsisVertical,
  exchange: Exchange,
  exclamation: Exclamation,
  expand: Expand,
  external: External,
  externalLine: ExternalLine,
  eye: Eye,
  faq: Faq,
  filter: Filter,
  globe: Globe,
  hourglass: Hourglass,
  img: Img,
  innovation: Innovation,
  license: License,
  loading: Loading,
  lock: Lock,
  lookup: Lookup,
  menu: Menu,
  orders: Orders,
  pdf: Pdf,
  partnership: Partnership,
  performance: Performance,
  personalisation: Personalisation,
  play: Play,
  policies: Policies,
  pound: Pound,
  ppt: Ppt,
  preferences: Preferences,
  products: Products,
  profile: Profile,
  question: Question,
  reports: Reports,
  request: Request,
  results: Results,
  search: Search,
  signOut: SignOut,
  sortFilter: SortFilter,
  tag: Tag,
  technicalGuides: TechnicalGuides,
  training: Training,
  trust: Trust,
  txt: Txt,
  tick: Tick,
  tickLine: TickLine,
  time: Time,
  trash: Trash,
  user: User,
  userList: UserList,
  users: Users,
  wrench: Wrench,
  xls: Xls,
  zip: Zip
}

export default IconMapper
